export const formatBackendEnv = (env: string) => `[${env.toUpperCase()}]`;
